import axios from 'axios';
export const submit = {
  methods: {
    submit: function () {
      const self = this;

      if (self.isDemo) {
        return;
      }

      this.loading = true;
      self.loadingProgress = 2;

      let messageChanger = setInterval(function(){
        self.showMessage = (self.showMessage + 1) % (self.loadingMessages.length - 1);
        if (self.loadingPercent < 90) {
          self.loadingProgress += 5;
        }
      }, 7000);
      axios.post( self.remote_server + process.env.SUBMIT_URL, self.formdata, { timeout: 30000 } )
      .then(response => {
        // JSON responses are automatically parsed.
        self.response = response.data

        if (!self.response.hasError) { // Make sure there wasn't an error
          self.tryNowCreated = 'Success';

          if (self.response.marketo) { // Check that we want to send to marketo
            try {
              self.send(false);
            }
            catch(e) {
              self.hasError('Catch', e, 'MKTO', messageChanger);

              self.$refs.form.dispatchEvent(new Event('submit', { cancelable: true })); // Send form submit event for zoominfo
            }
          }
        }
        else if( self.response.errorCode === 5001) {
          self.tryNowCreated = self.response.errorCode;
          // Set the final update message and cancel the rotating message
          if (self.response.redirect !== "ForgotPassword") {
            window.location.href = self.response.redirect;
          }
          else {
            console.log('Existing User');
          }
        }
        else {
          self.tryNowCreated = self.response.error;
          self.hasError('Catch', self.response.error, 'Submit 1', messageChanger);
        }

        if (!self.response.hasError && !self.isContent) { // Make sure there wasn't an error
          // Poll the service until the trial is setup ever 5 seconds
          if(typeof self.response.requestId !== 'undefined' && !self.response.hasError) {
            self.poll_results(messageChanger);
          }
          else {
            self.hasError('Catch', "No ID returned", 'Submit 2', messageChanger);
          }
        }

      })
      .catch(e => {
        self.tryNowCreated = e;
        self.hasError('Catch', e, 'Submit 3', messageChanger);

        try {
          self.send(true);
        }
        catch(e) {
          self.hasError('Catch', e, 'MKTO', messageChanger);

          //window.location.href = '/' + self.$route.params.segment + '/thank-you/'; // Redirect to the thank you page.
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/exports/methods/submit.js